export default __webpack_public_path__ + "static/media/ico-sq-9-industry.e6e445e3.svg";